import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import Navvy from './navvy';
import { NavSmartActions } from '~/components/nav/nav-smart-actions';
import useSmartNav from '~/hooks/use-smart-nav';
import DesktopTitledLayout from './desktop-layout';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import RequireCustomer from './require-customer';
import { Suspense, useMemo } from 'react';
import { sanitisedRoutesOfTools } from '~/routes/groups/tools';
import MobileLayout from './mobile-layout';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { showSmartActions, currentPageRoute } = useSmartNav();
  const { t } = useTranslation(TranslationNamespaces.MYACCOUNT);
  const toolsRoutes = useMemo(() => sanitisedRoutesOfTools(), []);
  const showRatesLayout =
    SettingsCache.settings.Features.includes('RatesSidepanel') && currentPageRoute === RoutingConstants.Pricing;

  if (isXs) {
    return (
      <MobileLayout>
        {showSmartActions && (
          <Suspense>
            <RequireCustomer isXs={isXs} silent={true}>
              <NavSmartActions isXs={isXs} wrapper={(x) => <>{x}</>} contained={false} />
            </RequireCustomer>
          </Suspense>
        )}
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout
      title={
        showRatesLayout
          ? t('SIDEBAR_RATES_LINK', { defaultValue: 'Rates' })
          : t('TOOLS_AREA_TITLE', { defaultValue: 'Tools' })
      }
    >
      {!showRatesLayout && (
        <Suspense>
          <Navvy routes={toolsRoutes} prefix="TOOLS" />
        </Suspense>
      )}
      {showSmartActions && (
        <Suspense>
          <RequireCustomer isXs={isXs} silent={true}>
            <NavSmartActions isXs={isXs} wrapper={(x) => <>{x}</>} contained={false} />
          </RequireCustomer>
        </Suspense>
      )}
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'Tools';
